"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateUnix = void 0;
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var dateUnix = function (dateJson) {
    return (0, moment_timezone_1.default)(dateJson).unix();
};
exports.dateUnix = dateUnix;
